import Vue from 'vue'
import Router from 'vue-router'
import store from "@/store/store";
import Service from "@/service/api";
import { isTokenExpired } from "@/router/middlewares/auth-guard";
//Mockup
//login
const MLogin = () => import('@/pages/view/Login')
const UserManual = () => import('@/pages/view/UserManual')
const ProfilePage = () => import('@/pages/common/ProfilePage')
const TicketDetailRoute = () => import('@/pages/common/TicketDetailRoute')
//Admin
const ATheContainer = () => import('@/components/admin/TheContainer')
const ABuildingManagement = () => import('@/pages/admin/BuildingManagement')
const AJobTypeManagement = () => import('@/pages/admin/JobTypeManagement')
const ADepartmentManagement = () => import('@/pages/admin/DepartmentManagement')
const AUsersList = () => import('@/pages/admin/usersList')
const AAdminDashboard = () => import('@/pages/admin/AdminDashboard')
const ATechnicianEvaluation = () => import('@/pages/admin/TechnicianEvaluation')
const ARequesterOrganizationSync = () => import('@/pages/admin/RequesterOrganizationSync')
const AdminHome = () => import('@/pages/admin/AdminHome')
const AdminHistory = () => import('@/pages/admin/History')
//User
const Userhomepage = () => import('@/pages/user/mainuser')
const NewRequest = () => import('@/pages/user/NewRequest')
const UserHistory = () => import('@/pages/user/History')
const Ucontainer = () => import('@/components/user/Ucontainer')


//Supervisor
const STheContainer = () => import('@/components/supervisor/TheContainer')
const SUsersList = () => import('@/pages/supervisor/usersList')
const SReportDetail = () => import('@/pages/supervisor/ReportDetail')
const SJobTypeManagement = () => import('@/components/supervisor/JobList')
const SupervisorDashboard = () => import('@/pages/supervisor/SupervisorDashboard')
const SupervisorHome = () => import('@/pages/supervisor/SupervisorHome')
const SupervisorHistory = () => import('@/pages/supervisor/History')
//Technician
const TAdminDashboard = () => import('@/pages/technician/TechnicianDashboard')
const TechnicianHome = () => import('@/pages/technician/TechnicianHome')
const TechnicianHistory = () => import('@/pages/technician/History')
const TTheContainer = () => import('@/components/technician/TheContainer')

Vue.use(Router)

const router = new Router({
  mode: 'history',
  linkActiveClass: 'open active',
  scrollBehavior: () => ({ y: 0 }),
  routes: [
    {
      path: '/',
      redirect: '/login',
      name: 'Mockup',
      component: {
        render(c) { return c('router-view') }
      },
      children: [
        {
          path: 'login',
          name: 'Mlogin',
          component: MLogin,
          meta: { requiresAuth: false }
        },
        {
          path: 'google/callback',
          name: 'GoogleCallback',
          component: MLogin,
          meta: { requiresAuth: false }
        },
        {
          path: 'user',
          redirect: 'user/mainuser',
          name: 'MHome',
          component: Ucontainer,
          meta: { roles: ['user'] },
          children: [
            {
              path: 'mainuser',
              name: 'Userhomepage',
              component: Userhomepage
            },
            {
              path: 'new-request',
              name: 'UserNewRequest',
              component: NewRequest
            },
            {
              path: 'manual',
              name: 'UManual',
              component: UserManual
            },
            {
              path: 'history',
              name: 'UserHistory',
              component: UserHistory
            },
            {
              path: 'profile',
              name: 'UserProfile',
              component: ProfilePage
            },
          ]
        },
        {
          path: 'student-affairs',
          redirect: '/student-affairs/dashboard',
          component: () => import('@/pages/student-affairs/Container.vue'),
          meta: { roles: ['student_affairs'] },
          children: [
            { path: 'dashboard', name: 'StudentAffairsDashboard', component: () => import('@/pages/student-affairs/Overview.vue'), props: { dashboard: true } },
            { path: 'home', name: 'StudentAffairsHome', component: () => import('@/pages/student-affairs/Overview.vue') },
            { path: 'home/:ticketId', name: 'StudentAffairsDetail', component: () => import('@/pages/student-affairs/Detail.vue'), props: true },
            { path: 'new-request', name: 'StudentAffairsNewRequest', component: NewRequest },
            { path: 'my-reports', name: 'StudentAffairsMyReports', component: () => import('@/pages/student-affairs/MyReports.vue') },
            { path: 'my-reports/:ticketId', name: 'StudentAffairsPersonalDetail', component: () => import('@/pages/student-affairs/PersonalDetail.vue'), props: true },
            { path: 'profile', name: 'StudentAffairsProfile', component: ProfilePage },
            { path: 'manual', name: 'StudentAffairsManual', component: UserManual },
          ],
        },
        {
          path: 'admin',
          redirect: 'admin/dashboard',
          name: 'MHome',
          component: ATheContainer,
          meta: { roles: ['admin'] },
          children: [
            {
              path: 'main',
              redirect: 'mainadmin'
            },
            {
              path: 'mainadmin',
              name: 'AdminHome',
              component: AdminHome
            },
            {
              path: 'dashboard',
              name: 'ADashboard',
              component: AAdminDashboard
            },
            {
              path: 'evaluation',
              name: 'ATechnicianEvaluation',
              component: ATechnicianEvaluation
            },
            {
              path: 'reportlist',
              redirect: to => to.query.tab === 'history'
                ? '/admin/history'
                : '/admin/mainadmin'
            },
            {
              path: 'history',
              name: 'AdminHistory',
              component: AdminHistory
            },
            {
              path: 'reportlist/:ticket_id',
              name: 'AReportDetail',
              component: TicketDetailRoute,
              props: route => ({ ticketId: route.params.ticket_id, detailRole: 'admin' }),
            },
            {
              path: 'job-type',
              name: 'AJobTypeManagement',
              component: AJobTypeManagement,
              props: true,
            },
            {
              path: 'department',
              redirect: '/admin/job-type'
            },
            {
              path: 'building',
              name: 'ABuildingManagement',
              component: ABuildingManagement,
              props: true,
            },
            {
              path: 'requester-organization-sync',
              name: 'ARequesterOrganizationSync',
              component: ARequesterOrganizationSync,
            },

            {
              path: 'UsersList',
              name: 'AUsersList',
              component: AUsersList,

            },
            {
              path: 'manual',
              name: 'AManual',
              component: UserManual
            },
            {
              path: 'new-request',
              name: 'AdminNewRequest',
              component: NewRequest
            },
            {
              path: 'profile',
              name: 'AdminProfile',
              component: ProfilePage
            },
          ]
        },
        {
          path: 'supervisor',
          redirect: 'supervisor/dashboard',
          name: 'MHome',
          component: STheContainer,
          meta: { roles: ['supervisor'] },
          children: [
            {
              path: 'main',
              redirect: 'mainsupervisor'
            },
            {
              path: 'mainsupervisor',
              name: 'SupervisorHome',
              component: SupervisorHome
            },
            {
              path: 'dashboard',
              name: 'SDashboard',
              component: SupervisorDashboard
            },
            {
              path: 'evaluation',
              name: 'STechnicianEvaluation',
              component: ATechnicianEvaluation
            },
            {
              path: 'reportlist',
              redirect: to => to.query.tab === 'history'
                ? '/supervisor/history'
                : '/supervisor/mainsupervisor'
            },
            {
              path: 'history',
              name: 'SupervisorHistory',
              component: SupervisorHistory
            },
            {
              path: 'reportlist/:ticket_id',
              name: 'SReportDetail',
              component: TicketDetailRoute,
              props: true,
              props: route => ({ ticketId: route.params.ticket_id, detailRole: 'supervisor' }),
              beforeEnter: (to, from, next) => {
                if (false && !to.params.report) {
                  next('/supervisor/mainsupervisor');
                } else {
                  next();
                }
              }
            },
            {
              path: 'UsersList',
              name: 'SUsersList',
              component: SUsersList,

            },
            {
              path: 'job-type',
              name: 'SJobTypeManagement',
              component: SJobTypeManagement,
              props: true,
            },
            {
              path: 'manual',
              name: 'SManual',
              component: UserManual
            },
            {
              path: 'new-request',
              name: 'SupervisorNewRequest',
              component: NewRequest
            },
            {
              path: 'profile',
              name: 'SupervisorProfile',
              component: ProfilePage
            },
          ]
        },
        {
          path: 'technician',
          redirect: 'technician/dashboard',
          name: 'MHome',
          component: TTheContainer,
          meta: { roles: ['technician'] },
          children: [
            {
              path: 'main',
              redirect: 'dashboard'
            },
            {
              path: 'maintechnician',
              name: 'TechnicianHome',
              component: TechnicianHome
            },
            {
              path: 'dashboard',
              name: 'TDashboard',
              component: TAdminDashboard
            },
            {
              path: 'reportlist',
              redirect: to => to.query.tab === 'history'
                ? '/technician/history'
                : '/technician/maintechnician'
            },
            {
              path: 'history',
              name: 'TechnicianHistory',
              component: TechnicianHistory
            },
            {
              path: 'reportlist/:ticket_id',
              name: 'TReportDetail',
              component: TicketDetailRoute,
              props: route => ({ ticketId: route.params.ticket_id, detailRole: 'technician' }),
            },
            {
              path: 'manual',
              name: 'TManual',
              component: UserManual
            },
            {
              path: 'new-request',
              name: 'TechnicianNewRequest',
              component: NewRequest
            },
            {
              path: 'profile',
              name: 'TechnicianProfile',
              component: ProfilePage
            },
          ]
        }
      ]
    }
  ]
})


router.beforeEach(async (to, from, next) => {
  let accessToken = localStorage.getItem("accessToken");
  const refreshToken = localStorage.getItem("refreshToken");

  // 1. ดึง User Role LocalStorage)
  let userRole = null;
  const userStored = localStorage.getItem("user");
  if (userStored) {
    try {
      userRole = JSON.parse(userStored).role;
    } catch (e) {
      userRole = null;
    }
  }

  // เช็คว่าเป็นหน้า Login ไหม
  if (to.path === '/login' || to.name === 'Mlogin') {
    if (accessToken && !isTokenExpired(accessToken)) {
      // ถ้า login อยู่แล้ว ให้ดีดไปตาม role
      if (userRole === 'admin') return next('/admin/dashboard');
      if (userRole === 'student_affairs') return next('/student-affairs/dashboard');
      if (userRole === 'supervisor') return next('/supervisor/dashboard');
      if (userRole === 'technician') return next('/technician/dashboard');
      return next('/user');
    }
    return next();
  }

  // กรณีไม่มี Token อะไรเลย
  if (!accessToken && !refreshToken) {
    return next('/login');
  }

  // กรณี Access Token หมดอายุ หรือ ไม่มี Access Token แต่มี Refresh Token
  if (isTokenExpired(accessToken) || !accessToken) {
    if (refreshToken) {
      try {
        // ขอ Token ใหม่
        const response = await Service.auth('refresh-token', { refreshToken });
        const newAccessToken = response.data.accessToken;

        // บันทึกค่าใหม่
        localStorage.setItem("accessToken", newAccessToken);
        accessToken = newAccessToken;

      } catch (error) {
        console.error("Auto Login Failed:", error);
        // Refresh Token หมดอายุ -> Logout
        store.dispatch('oAuth/logout');
        return next('/login');
      }
    } else {
      // หมดอายุและไม่มี Refresh Token
      store.dispatch('oAuth/logout');
      return next('/login');
    }
  }

  const requiredRoles = to.matched.find(record => record.meta.roles)?.meta.roles;

  if (requiredRoles) {
    if (!requiredRoles.includes(userRole)) {
      // alert("คุณไม่มีสิทธิ์เข้าถึงหน้านี้");

      if (userRole === 'admin') return next('/admin/dashboard');
      if (userRole === 'student_affairs') return next('/student-affairs/dashboard');
      if (userRole === 'supervisor') return next('/supervisor/dashboard');
      if (userRole === 'technician') return next('/technician/dashboard');
      return next('/user');
    }
  }

  next();
});

export default router;
